import { createStackNavigator } from "@react-navigation/stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const WorkspaceTodoStack =
  createStackNavigator<WorkspaceTodoStackParamList>();

type WorkspaceTodoStackParamList = {
  WorkspaceTodosMain: object;
  WorkspaceTodoDetail: {
    todoWorkspaceId: string;
  };
  WorkspaceTodosArchived: object;
};

export type WorkspaceNavigationProp<
  T extends keyof WorkspaceTodoStackParamList,
> = CompositeNavigationProp<
  NativeStackNavigationProp<WorkspaceTodoStackParamList, T>,
  UserLoggedInNavigatorNavigationProp<"OrgHome">
>;

export type WorkspaceTodoStackScreenProps<
  T extends keyof WorkspaceTodoStackParamList,
> = {
  route: RouteProp<WorkspaceTodoStackParamList, T>;
  navigation: WorkspaceNavigationProp<T>;
};
